import script from "./SegmentComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SegmentComponent.vue?vue&type=script&setup=true&lang=js"

import "./SegmentComponent.vue?vue&type=style&index=0&id=43ed14ca&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43ed14ca"]])

export default __exports__